export default (context) => {
    if(context.timeLeft < context.testConfig.NOTIFY_UPLOAD_BEFORE && !context.notifyUploadSheet) {
        context.uploadDialog      = context.testConfig.HIDE_PRE_SUBMIT
        context.notifyUploadSheet = true
        if(context.uploadDialog==false) context.$store.commit('open_snackbar', {text: 'Test is about to end soon.', color: 'blue'}) 
        else context.$store.commit('open_snackbar', {text: 'Only 10 mins left. Please submit your answer sheet.', color: 'blue'}) 
    }
}